import { FC, memo } from 'react'
import { Box, useToken, useColorModeValue } from '@chakra-ui/react'

type Props = {
  size?: number | string
}

const DefaultAvatarIllustration: FC<Props> = (props) => {
  const [primary100, primary500] = useToken('colors', ['primary.100', 'primary.500'])

  function getSize() {
    switch (props?.size) {
    case '2xs':
      return 'var(--chakra-sizes-4)'
    case 'xs':
      return 'var(--chakra-sizes-6)'
    case 'sm':
    default:
      return 'var(--chakra-sizes-8)'
    case 'md':
      return 'var(--chakra-sizes-12)'
    case 'lg':
      return 'var(--chakra-sizes-16)'
    case 'xl':
      return 'var(--chakra-sizes-24)'
    case '2xl':
      return 'var(--chakra-sizes-32)'
    }
  }

  const bgColor = useColorModeValue(primary100, primary500)

  return (
    <Box w={getSize()} h={getSize()} pos="relative">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 386 386">
        <g id="Container">
          <circle cx="393.7" cy="402.26" r="188" transform="translate(-369.83 186.95) rotate(-45)" fill={bgColor} />
          <path
            fill={bgColor}
            d="M393.7,219.26a183,183,0,1,1-129.4,53.6,181.77,181.77,0,0,1,129.4-53.6m0-10c-106.59,0-193,86.41-193,193s86.41,193,193,193,193-86.41,193-193-86.41-193-193-193Z"
            transform="translate(-200.7 -209.26)"
          />
        </g>
        <g id="User">
          <path
            d="M316,572l-46-31c0-43.59,36.29-75.68,79.89-75.68h90.63c43.59,0,75.48,34.09,75.48,77.68l-46,28c-31,13-56,18-73,17C377,586.83,361,587,316,572Z"
            transform="translate(-200.7 -209.26)"
            fill="white"
          />
          <path
            d="M448.55,282.35a75.44,75.44,0,1,1-106.69,0,75.44,75.44,0,0,1,106.69,0"
            transform="translate(-200.7 -209.26)"
            fill="white"
          />
        </g>
        <g id="Border">
          <path
            d="M393.7,219.26a183,183,0,1,1-129.4,53.6,181.77,181.77,0,0,1,129.4-53.6m0-10c-106.59,0-193,86.41-193,193s86.41,193,193,193,193-86.41,193-193-86.41-193-193-193Z"
            transform="translate(-200.7 -209.26)"
            fill={bgColor}
          />
        </g>
      </svg>
    </Box>
  )
}

export default memo(DefaultAvatarIllustration)
